//TODO: uncomment
import api_fabric from "../../api/ApiFabric";

//TODO: remove mock
// import { wallets as wallets_mock } from "../../../../tests/mocks/wallets.js";

/**
 *
 * @return {Wallets}
 */
//TODO: uncomment
const api = function() {
  return api_fabric.getInstance("Wallets", true);
};

const wallets = {
  namespaced: true,

  state: {
    hard: 0,
    soft: 0,
    victory: 0,
    victory_vip: 0,
  },

  mutations: {
    setWalletsState(state, wallets_data) {
      state.hard = wallets_data.hard;
      state.soft = wallets_data.soft;
      state.victory = wallets_data.victory;
      state.victory_vip = wallets_data.victory_vip;
    },
    removeHard(state, value) {
      state.hard -= value;
    },
    removeSoft(state, value) {
      state.soft -= value;
    },
  },

  getters: {
    getWalletsState(state) {
      return state;
    },
  },

  actions: {
    getWalletsData({ commit }) {
      //TODO: remove mock
      // commit("setWalletsState", wallets_mock);

      return new Promise(resolve => {
        api()
          .getUserWallets()
          .then(response => {
            if (response.success) {
              commit("setWalletsState", response.success.data.data);

              resolve();
            }
          });
      });
    },
  },
};

export default wallets;
